import ThemeInterface from '../ThemeInterface';

const core = {
  brand: '#1f4247',
  accent: '#328793',
  foreground: '#333',
  neutral: '#dae2e3',
  border: '#999',
  
  typography: {
    primary: 'OpenSans, Helvetica, sans-serif',
    secondary: 'Cabin, Helvetica, sans-serif',
  },
};

export default {
  core,
  header: {
    logoHeight: 32,
    mobileLogoHeight: 30,
  },
  sectionHeader: {
    fontSize: 22,
    letterSpacing: 0.5,
  },
  button: {
    letterSpacing: 0,
    borderRadius: 1,
    primary: {
      backgroundColour: core.accent,
      backgroundColourOnHover: '#4fb5c3',
    },
    secondary: {
      backgroundColour: core.foreground,
      borderColour: core.brand,
      backgroundColourOnHover: '#4d4d4d',
    },
    large: {
      fontSize: 21,
      lineHeight: 1.4,
    },
  },
} as ThemeInterface;
